<div class="loyalty-container">
  <span class="loyalty-title" [innerHTML]="titleKey | translate: titleParams"></span>
  <div *ngFor="let stat of statsData" class="loyalty-stat-block">
    <span class="typography-title-s">{{ stat.label }}</span>
    <app-bar-percent [percent]="stat.percent ?? 0"></app-bar-percent>
    <app-stats class="typography-body-m" [data]="stat"></app-stats>
  </div>
</div>